<template>
  <div
    class="incoming-tender-list-row incoming-tender-list-row_breakdown incoming-tender-list-row_breakdown-value"
  >
    <div class="tender-list-cell tender-list-cell_numbering">
      {{ parentRowIndex + 1 }}.{{ rowIndex + 1 }}
    </div>
    <IncomingTenderListCell
      :currency="currency"
      :row="row"
      :is-number="false"
      field="description_of_works"
      class="tender-list-cell_description"
      is-breakdown
    />
    <div class="tender-list-cell">
      {{ unitName(row.unit.name) }}
    </div>
    <IncomingTenderListCell
      :currency="currency"
      :row="row"
      is-quantity
      field="quantity"
      is-breakdown
      class="right-border"
    />
    <div
      v-for="elem in GENERAL_ESTIMATE_COLUMN_WIDTH"
      :key="`general-${elem}`"
      class="tender-list-cell"
      :class="{ 'right-border': elem === GENERAL_ESTIMATE_COLUMN_WIDTH }"
    />
    <div v-for="elem in countOfLeftSpaceCells" :key="`before-${elem}`" class="tender-list-cell" />
    <IncomingTenderListCell
      v-for="column in columnKeys"
      :key="`cell-${column.title}`"
      :currency="currency"
      :row="row"
      :field="column.title"
      is-breakdown
      :class="{
        'right-border': column.title === 'total_total',
        'left-border': column.title === 'total' && countOfLeftSpaceCells,
      }"
    />
    <div v-for="elem in countOfRightSpaceCells" :key="`after-${elem}`" class="tender-list-cell" />
  </div>
</template>

<script>
  import IncomingTenderListCell from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListCell';
  import { mapState } from 'vuex';
  import {
    GENERAL_ESTIMATE_COLUMN_WIDTH,
    DEFAULT_COLUMN_WIDTH,
    WIDE_COLUMN_DELTA,
  } from '@/containers/tender/tender-list/constants';
  import unitName from '@/utils/mixins/get-unit-name';

  export default {
    name: 'TenderListBreakdownRow',
    components: {
      IncomingTenderListCell,
    },
    props: {
      currency: {
        type: String,
        required: true,
      },
      indexPriority: {
        type: Number,
        required: true,
      },
      openedColumnsBefore: {
        type: Number,
        required: true,
      },
      openedColumnsAfter: {
        type: Number,
        required: true,
      },
      isOpened: {
        type: Boolean,
        required: true,
      },
      cellGroupsAfter: {
        type: Number,
        required: true,
      },
      rowIndex: {
        type: Number,
        required: true,
      },
      row: {
        type: Object,
        required: true,
      },
      parentRowIndex: {
        type: Number,
        required: true,
      },
    },
    mixins: [unitName],
    data() {
      return {
        GENERAL_ESTIMATE_COLUMN_WIDTH,
      };
    },
    computed: {
      ...mapState('global', ['units']),
      countOfLeftSpaceCells() {
        return (
          this.indexPriority * DEFAULT_COLUMN_WIDTH + this.openedColumnsBefore * WIDE_COLUMN_DELTA
        );
      },
      countOfRightSpaceCells() {
        return (
          this.cellGroupsAfter * DEFAULT_COLUMN_WIDTH + this.openedColumnsAfter * WIDE_COLUMN_DELTA
        );
      },
      columnKeys() {
        return this.isOpened
          ? [
              {
                title: 'total',
                canBeEdited: false,
              },
              {
                title: 'labour_total',
                canBeEdited: false,
              },
              {
                title: 'materials_total',
                canBeEdited: false,
              },
              {
                title: 'tools_total',
                canBeEdited: false,
              },
              {
                title: 'total_total',
                canBeEdited: false,
              },
            ]
          : [
              {
                title: 'total',
                canBeEdited: false,
              },
              {
                title: 'total_total',
                canBeEdited: false,
              },
            ];
      },
    },
  };
</script>
